import { css } from '@emotion/core';

import {
  fontSize,
  fontWeight,
  leftString,
  rightString,
  shadowBorder,
  shadowBorderBottom,
} from 'src/design-system/mixins';
import { responsive } from 'src/design-system/style-utils';
import { Theme } from 'src/design-system/theme';

import type { Props } from './TextArea';

const textarea =
  ({ err = false, marginBottom = '0', rows, resize = 'none', touched = false, size }: Props) =>
  (theme: Theme) => {
    const normalSize = size === 'normal';
    const fontSizing = normalSize ? 'md' : 'sm';
    const paddingSize = size === 'normal' ? 'lg' : 'sm';

    return css`
      ${fontWeight('normal')(theme)};
      ${fontSize(fontSizing)(theme)}
      ${shadowBorderBottom('dark')(theme)}
      background: ${theme.colors.grey5};
      border: none;
      color: ${theme.fontColors.dark};
      height: ${rows ? 'auto' : '90px'};
      resize: ${resize};
      outline: none;
      width: 100%;
      padding-top: ${normalSize ? theme.paddings.sm : 6}px;
      padding-bottom: ${normalSize ? theme.paddings.sm : 6}px;
      padding-${leftString(theme)}: ${theme.paddings[paddingSize]}px;
      padding-${rightString(theme)}: ${theme.paddings[paddingSize]}px;
      border-radius: 0px;
      -webkit-appearance: none;
      ${responsive(
        marginBottom,
        (marginBottom) =>
          css`
            margin-bottom: ${theme.margins[marginBottom]}px;
          `
      )};
      ::placeholder {
        color: ${theme.fontColors.grey};
      }
      :focus {
        ${shadowBorder('dark')(theme)}
        background: ${theme.colors.light};
      }
      ${
        err &&
        touched &&
        css`
          ${shadowBorder('error', 2)(theme)}
          :placeholder-shown {
            ${shadowBorder('error', 2)(theme)}
          }
          :focus {
            ${shadowBorder('error', 2)(theme)}
          }
        `
      }
      :disabled {
        box-shadow: none;
        color: ${theme.fontColors.disabled};
      }
    `;
  };

const styles = { textarea };
export default styles;
